export default __webpack_public_path__ + "static/media/Animals_06.315e8a13.png";